import PropTypes from 'prop-types';

import map from 'lodash/fp/map';

import { legacyTheme, styled } from '@prose-ui/legacy';
import { withStyles } from 'legacyStyles';
import MarkdownIt from 'markdown-it';

import Collapse from 'Components/Collapse';
import { breakpoints } from 'Components/ThemeProvider';
import { Typography } from 'Components/Typography';

import useMedia from 'utils/useMedia';

const md = new MarkdownIt();

const CollapseWrapper = styled('div')({
  width: '100%',
  marginTop: 24,
  padding: 30,
});

const StyledCollapse = withStyles(Collapse, {
  root: {
    marginBottom: 28,
    width: '100%',
    border: 'none',
    textAlign: 'left',
    '&:not(:last-child)': {
      borderBottom: `1px solid rgba(166,166,166,0.3)`,
    },
  },
});

const PercBlocksWrapper = styled('div')({
  display: 'flex',
  width: '100%',
  flexWrap: 'wrap',
  justifyContent: 'center',
  // alignItems: 'center',
  textAlign: 'center',
  padding: 30,
  [legacyTheme.breakpoints.match('lg')]: {
    maxWidth: 800, // Arbitrary value to force 2x2 blocks
  },
});

const PercBlock = styled('div')({
  width: 270,
  margin: 15,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const LineSeperator = styled('div')({
  width: '100%',
  margin: 18,
  borderTop: `1px solid rgba(166,166,166,0.3)`,
});

const TextPercs = ({ textContent }) => {
  const isMobile = useMedia(`(max-width: ${breakpoints.sm - 1}px)`);

  return isMobile ? (
    <CollapseWrapper>
      {map(
        ([key, { title, paragraph }]) => (
          <StyledCollapse
            key={key}
            answer={
              <>
                <span dangerouslySetInnerHTML={{ __html: md.render(paragraph) }} />
                <br />
              </>
            }
            question={title}
            questionTypographyVariant="h3"
          />
        ),
        Object.entries(textContent)
      )}
    </CollapseWrapper>
  ) : (
    <PercBlocksWrapper>
      {map(
        ([key, { title, paragraph }]) => (
          <PercBlock key={key}>
            <Typography variant="h3" whiteSpace="pre-line">
              {title}
            </Typography>
            <LineSeperator />
            <Typography
              color="grey"
              dangerouslySetInnerHTML={{ __html: md.render(paragraph) }}
              variant="p2"
            />
          </PercBlock>
        ),
        Object.entries(textContent)
      )}
    </PercBlocksWrapper>
  );
};

TextPercs.propTypes = {
  textContent: PropTypes.shape({}).isRequired,
};

export default TextPercs;
